addEventListener( 'DOMContentLoaded', function () {
	let swipers = [];


	const initSwipers = () => {
		// Destroy existing swipers
		swipers.forEach( ( swiper ) => swiper.destroy( true, true ) );
		swipers = [];

		if ( typeof Swiper === 'undefined' ) return;

		// Initialize new swipers
		const swiperElements = document.querySelectorAll( '.b-card-carrusel__swiper' );
		swiperElements.forEach( ( element ) => {

			const wrapper = element.closest( '.b-card-carrusel__wrapper' );
			if ( ! wrapper ) {
				return;
			}

			const paginationEl = wrapper.querySelector(
				'.b-card-carrusel__progress'
			);

			const nextEl = wrapper.querySelector( '.b-card-carrusel__swiper-button-next' );
			const prevEl = wrapper.querySelector( '.b-card-carrusel__swiper-button-prev' );
			const navWrap = element.parentElement;

			const blockRoot = wrapper.closest( '.b-card-carrusel' );
			const isFourCards =
				blockRoot && blockRoot.classList.contains( 'is-style-4-cards' );

			const breakpoints = isFourCards
				? {
						768: {
							slidesPerView: 2.1,
						},
						1024: {
							slidesPerView: 3.1,
						},
						1280: {
							slidesPerView: 4,
						},
					}
				: {
						768: {
							slidesPerView: 2,
						},
						1024: {
							slidesPerView: 3,
						}
					};

			const swiperConfig = {
				slidesPerView: 1.15,
				spaceBetween: 8,
				loop: false,
				watchOverflow: true,
				grabCursor: true,
				breakpoints,
			};

			if ( nextEl && prevEl ) {
				swiperConfig.navigation = { nextEl, prevEl };
			}

			const swiper = new Swiper( element, swiperConfig );

			// Manual progress bar via CSS custom property on the container.
			if ( paginationEl ) {
				const updateFill = () => {
					const perView = Number( swiper.params.slidesPerView );
					const slides = Array.from( swiper.slides );
					// js-hidden is applied directly on the swiper-slide element (b-card-image)
					const visibleSlides = slides.filter(
						( s ) => ! s.classList.contains( 'js-hidden' )
					);
					const visibleCount = visibleSlides.length;

					// Center the arrows on the card image rather than the whole card height.
					if ( navWrap ) {
						const imageEl = visibleSlides[ 0 ]?.querySelector(
							'.b-image-carrusel, .b-card-image__figure'
						);
						if ( imageEl ) {
							navWrap.style.setProperty(
								'--arrow-center',
								`${ imageEl.offsetHeight / 2 }px`
							);
						} else {
							navWrap.style.removeProperty( '--arrow-center' );
						}

						// On decimal slidesPerView a sliver of the next card peeks in on
						// the right; pull the next arrow in so it sits over the last
						// fully visible card, symmetric to the prev arrow over the first.
						if ( Number.isInteger( perView ) ) {
							navWrap.style.removeProperty( '--arrow-next-offset' );
						} else {
							const slideWidth = visibleSlides[ 0 ]?.offsetWidth || 0;
							const spaceBetween = Number( swiper.params.spaceBetween ) || 0;
							const fractional = perView - Math.floor( perView );
							const peekWidth = fractional * ( slideWidth + spaceBetween );
							navWrap.style.setProperty(
								'--arrow-next-offset',
								`${ peekWidth }px`
							);
						}
					}

					// Hide bar/arrows if all visible cards fit in the viewport without scrolling
					const needsNavigation = visibleCount > Math.ceil( perView );
					if ( nextEl ) {
						nextEl.style.display = needsNavigation ? '' : 'none';
					}
					if ( prevEl ) {
						prevEl.style.display = needsNavigation ? '' : 'none';
					}

					if ( ! needsNavigation ) {
						paginationEl.style.display = 'none';
						return;
					}

					paginationEl.style.display = '';

					// At the last snap point force 100% — Swiper may stop before the
					// last slide if the container is slightly wider than perView * slideWidth.
					// Guard against isBeginning to avoid false 100% on a locked swiper.
					if ( swiper.isEnd && ! swiper.isBeginning ) {
						paginationEl.style.setProperty( '--progress', 1 );
						return;
					}

					// Count visible cards that have been "seen":
					// all visible slides whose DOM position is within activeIndex + perView
					const seenCount = visibleSlides.filter(
						( s ) => slides.indexOf( s ) < Math.ceil( swiper.activeIndex + perView )
					).length;
					const progress = Math.min( seenCount / visibleCount, 1 );
					paginationEl.style.setProperty( '--progress', progress );
				};

				swiper.on( 'slideChange', updateFill );
				swiper.on( 'breakpoint', updateFill );
				swiper.on( 'resize', updateFill );
				updateFill();

				// Expose so filter tabs can reset position and update the bar
				element._resetProgress = () => {
					swiper.slideTo( 0, 0 );
					requestAnimationFrame( updateFill );
				};
			}

			swipers.push( swiper );
		} );
	};

	// Initialize on load
	initSwipers();

	const filterTabs = document.querySelectorAll('.b-card-carrusel .c-filter-tabs__button');

	console.log(filterTabs);
	filterTabs.forEach(tab => {
		const parentFilter = tab.closest('.b-card-carrusel');
		const currentSwiper = parentFilter.querySelector('.b-card-carrusel__swiper');
		const gallerySections = parentFilter.querySelectorAll('.b-card-image[data-tab]');

		tab.addEventListener('click', function() {
			filterTabs.forEach(tab => {
				tab.classList.remove('js-active');
			});
			tab.classList.add('js-active');

			const filterSlug = tab.dataset.tab;
			if (filterSlug === 'all') {
				gallerySections.forEach(section => {
					section.classList.remove('js-hidden');
				});
			} else {
				gallerySections.forEach(section => {
					if (section.dataset.tab === filterSlug) {
						section.classList.remove('js-hidden');
					} else {
						section.classList.add('js-hidden');
					}
				});
			}

			// Reset progress bar to initial position after filter change
			currentSwiper._resetProgress?.();
		});


	});
} );
